import { SESSION_STORAGE_KEYS } from '@/constants/session-storage'

const { UCS_TOAST_MESSAGES, PAGE_ALERTS } = SESSION_STORAGE_KEYS

export const setStorageItem = ({ key, value, sessionBased = true }) => {
  if (sessionBased) {
    window.sessionStorage.setItem(key, value)
    return
  }

  window.localStorage.setItem(key, value)
}

export const getStorageItem = ({ key, sessionBased = true }) => {
  if (sessionBased) {
    return window.sessionStorage.getItem(key)
  }

  return window.localStorage.getItem(key)
}

export const removeStorageItem = ({ key, sessionBased = true }) => {
  if (sessionBased) {
    window.sessionStorage.removeItem(key)
    return
  }

  window.localStorage.removeItem(key)
}

export const getToastMessagesFromSessionStorage = () =>
  JSON.parse(getStorageItem({ key: UCS_TOAST_MESSAGES })) || {}

export const setToastMessageInSessionStorage = (eventId, formattedMessage) => {
  const toastMessages = getToastMessagesFromSessionStorage()
  toastMessages[eventId] = formattedMessage
  setStorageItem({ key: UCS_TOAST_MESSAGES, value: JSON.stringify(toastMessages) })
}

export const removeToastMessagesFromSessionStorage = () => {
  removeStorageItem({ key: UCS_TOAST_MESSAGES })
}

export const setPageAlertsInSessionStorage = ({
  type = 'success',
  contentId,
  estimatedDays = 10,
}) => {
  const alerts = JSON.stringify([
    {
      type,
      contentId,
      vars: { estimatedDays },
    },
  ])
  setStorageItem({
    key: PAGE_ALERTS,
    value: alerts,
  })
}
